/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { selectToggleValue } from '@zcode-ui/filters'
import { guessMapDimensions, selectMapDimensions } from '@zcode-ui/map'
import { getCommaSeparatedText } from '@zcode-ui/zumper-header'
import type { AutocompleteApiResult, AutocompleteCurrentPositionResult } from '@zcode/bizos'
import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import { connect } from 'react-redux'
import { default as navigateToAutocompleteResult } from '../../../../modules/autocomplete/thunks/navigateToAutocompleteResult'
import type { Dispatch, GetState } from '../../../../modules/types'
import { SearchForm } from './SearchForm'

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onSelectResult: async (result: AutocompleteApiResult | AutocompleteCurrentPositionResult) => {
      track({
        event: EVENT_NAMES.CLICK,
        payload: {
          [PROP_NAMES.PAGE_NAME]: 'Homepage',
          [PROP_NAMES.SECTION]: 'Set Location',
          [PROP_NAMES.CITY_STATE_LOCATION]: getCommaSeparatedText(result.city, result.state),
        },
      })
      dispatch(async (_, getState: GetState) => {
        const state = getState()
        const toggleValue = selectToggleValue(state)
        const isFullWidthMap = toggleValue === 'full-map'
        const mapDimensions = selectMapDimensions(state)
        const { height, width } = guessMapDimensions(mapDimensions, isFullWidthMap)
        await dispatch(navigateToAutocompleteResult({ result, height, width }))
      })
    },
  }
}

export const SearchFormContainer = connect(null, mapDispatchToProps)(SearchForm)
